jQuery(document).ready(function ($) {
  $('.accordion__item').on('click', 'h3 button', function (e) {
    e.preventDefault();

    if ($(this).closest('.accordion__item').hasClass('accordion__item--active')) {
      $(this).closest('.accordion__item').toggleClass('accordion__item--active');
      $(this).closest('.accordion__item').find('.accordion__info').slideUp();
    } else {
      $('.accordion__item').removeClass('accordion__item--active');
      $('.accordion__item .accordion__info').slideUp();
      $(this).closest('.accordion__item').toggleClass('accordion__item--active');
      $(this).closest('.accordion__item').find('.accordion__info').slideDown();
    }
  });
});
jQuery(document).ready(function ($) {
  // Hearts loading and unloading
  var delay = 300;
  setInterval(function () {
    $('.heart-lives svg').each(function () {
      var svg = $(this);
      setTimeout(function () {
        svg.find('.inner-heart').addClass('active');
      }, delay);
      delay += 300;
    });
    $('.heart-lives svg').reverse().each(function () {
      var svg = $(this);
      setTimeout(function () {
        svg.find('.inner-heart').removeClass('active');
      }, delay);
      delay += 300;
    });
  }, 1500);
  $(window).on('resize scroll', function (e) {
    if ($('.rainbow-html').length != 0 && $('.rainbow-html').isInViewport()) {
      $('.rainbow-html').addClass('visible');
    }
  });
});
jQuery.fn.reverse = [].reverse;

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
jQuery(document).ready(function ($) {
  // Product add to cart button click
  $('body').on('click', '.btn--atc', function (e) {
    e.preventDefault();
    var varId = $(this).data('var');
    var esrbRating = $(this).closest('.product').data('esrb_rating');
    var esrbList = $(this).closest('.product').data('esrb_list');
    var upsellId = $(this).closest('.product').data('upsell_id');
    var upsellTitle = $(this).closest('.product').data('upsell_title');
    var upsellPrice = $(this).closest('.product').data('upsell_price');
    CartJS.addItem(varId, 1, {
      'esrb_rating': esrbRating,
      'esrb_list': esrbList,
      'upsell_id': upsellId,
      'upsell_title': upsellTitle,
      'upsell_price': upsellPrice
    }, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      }
    });
  }); // Mini-cart upsell

  $('.mini-cart__products').on('click', '.upsell button', function (e) {
    e.preventDefault();
    var upsellId = $(this).closest('.upsell').data('upsell_id'); // var upsellTitle = $( this ).closest( '.upsell' ).data( 'upsell_title' );
    // var upsellPrice = $( this ).closest( '.upsell' ).data( 'upsell_price' );
    // // var upsellQty = $( this ).closest( '.product__info' ).find( '.qty-val' ).val();

    CartJS.addItem(upsellId, '1', {// 'upsell_id': upsellId,
      // 'upsell_title': upsellTitle,
      // 'upsell_price': upsellPrice
    }, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      }
    });
  }); // Product mini cart qty update

  $('.mini-cart__products').on('click', '.js-qty--mini', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    CartJS.updateItem(lineNum + 1, qtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
        console.log(textStatus);
        console.log(jqXHR);
      }
    });
  }); // Product ( not cart ) qty update

  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    console.log('testtt');
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
  }); // Remove product from mini cart

  $('.mini-cart__products').on('click', '.remove-product', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();
    $this.closest('.product').addClass('removed');
    CartJS.removeItem(lineNum + 1, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
        console.log(textStatus);
        console.log(jqXHR);
      }
    });
  }); // Close mini cart when click outside

  $(document).on("click", function (event) {
    // If the target is not the container or a child of the container, then process
    // the click event for outside of the container.
    if ($('.mini-cart').hasClass('cart--open') && $(event.target).closest(".mini-cart").length === 0) {
      $('.mini-cart').fadeOut();
      setTimeout(function () {
        $('.mini-cart').removeClass('cart--open');
      }, 100);
    }
  });
  /*** PDP ***/

  $('.pdp__info .btn--atc-pdp').on('click', function (e) {
    e.preventDefault();
    var varId = $('.pdp__info').attr('data-prod_var');
    var currentQty = $('input.qty-val').val();
    var esrbRating = $(this).closest('.pdp__info').data('esrb_rating');
    var esrbList = $(this).closest('.pdp__info').data('esrb_list');
    var upsellId = $(this).closest('.pdp__info').data('upsell_id');
    var upsellTitle = $(this).closest('.pdp__info').data('upsell_title');
    var upsellPrice = $(this).closest('.pdp__info').data('upsell_price');
    console.log(varId);
    CartJS.addItem(varId, currentQty, {
      'esrb_rating': esrbRating,
      'esrb_list': esrbList,
      'upsell_id': upsellId,
      'upsell_title': upsellTitle,
      'upsell_price': upsellPrice
    }, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      }
    });
  }); // MAIN CART
  // Qty

  $('.column--qty').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.product__qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var itemID = $this.closest('.cart-row').data('lineid');
    var lineNum = $this.closest('.cart-row').data('linenum');
    var variantID = $this.closest('.column--qty').data('variantid');
    var upsellId = $this.closest('.cart-row').find('.upsell').data('upsell_id');
    var upsellTitle = $this.closest('.cart-row').find('.upsell').data('upsell_title');
    var upsellPrice = $this.closest('.cart-row').find('.upsell').data('upsell_price');

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    if (qtyInputVal >= 1) {
      CartJS.updateItem(lineNum, qtyInputVal, {
        'upsell_id': upsellId,
        'upsell_title': upsellTitle,
        'upsell_price': upsellPrice
      }, {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON('/cart.js', function (cart) {
            $.each(cart.items, function (index, item) {
              if (item.id === itemID) {
                $('[data-lineid="' + itemID + '"] .column--total .body').text(formatter.format(item.final_line_price / 100));
                $('[data-lineid="' + itemID + '"] .column--qty input').val(item.quantity);
              }
            }); // $( '.subtotal-row .cart-subtotal' ).text( formatter.format(cart.items_subtotal_price / 100 ) );
            // $( '.mini-cart--trigger .cart-counter' ).text( cart.item_count );

            $('.cart__overview h1 .count').text('(' + cart.item_count + ')');
            $('.total-row span').text(formatter.format(cart.items_subtotal_price / 100));
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
          console.log(textStatus);
          console.log(jqXHR);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
          console.log(textStatus);
          console.log(jqXHR);
        }
      });
    }
  }); // Upsell

  $('.cart__table').on('click', '.upsell button', function (e) {
    e.preventDefault();
    var upsellId = $(this).closest('.upsell').data('upsell_id'); // var upsellTitle = $( this ).closest( '.upsell' ).data( 'upsell_title' );
    // var upsellPrice = $( this ).closest( '.upsell' ).data( 'upsell_price' );
    // // var upsellQty = $( this ).closest( '.product__info' ).find( '.qty-val' ).val();

    CartJS.addItem(upsellId, '1', {// 'upsell_id': upsellId,
      // 'upsell_title': upsellTitle,
      // 'upsell_price': upsellPrice
    }, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          location.reload();
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      }
    });
  }); // Cart Remove

  $('.cart-remove').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var itemID = $this.closest('.cart-row').data('lineid');
    var lineNum = $this.closest('.cart-row').data('linenum');
    $('.cart-row').each(function (index, value) {
      $dataLine = $(this).data('linenum');
      console.log($dataLine);
    });
    CartJS.removeItemById(itemID, {
      success: function success(data, textStatus, jqXHR) {
        // $this.closest( '.cart-row' ).addClass( 'removed' );
        // $this.closest( '.cart-row' ).remove();
        // // $( '.mini-cart--trigger .cart-counter' );
        // // updateFreeShipping();
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
        console.log(textStatus);
        console.log(jqXHR);
      }
    });
  }); // Cart Donate

  $('.donate input').change(function () {
    if (this.checked) {
      var varId = $(this).closest('label').data('varid');
      CartJS.addItem(varId, '1', {// 'upsell_id': upsellId,
        // 'upsell_title': upsellTitle,
        // 'upsell_price': upsellPrice
      }, {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON('/cart.js', function (cart) {
            location.reload();
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
        }
      });
    }
  });
  $('.variants__select select').on('change', function () {
    var varImg = $(this).find(':selected').attr('data-var_img');
    console.log($(this).find(':selected').attr('data-var_img'));
    setVarImg(varImg);
  });
}); // Go to variant specific image in slider when selected

function setVarImg(imgUrl) {
  if (imgUrl != '' || imgUrl != undefined) {
    $('.pdp-slider--thumb .slick-slide').each(function () {
      var slideSrc = $(this).find('img').attr('src');

      if (slideSrc == imgUrl) {
        console.log('matched');
        $(this).closest('.slick-slide').click();
      }
    });
  }
} // Update mini cart after product added


function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = '';
  $.each(cartItems, function (index, item) {
    newCartHtml += '<div class="product product--cart d-flex space-between"  data-lineid="' + item.id + '">';
    newCartHtml += '<div class="product__image">';
    newCartHtml += '<a href="' + item.url + '">';
    newCartHtml += '<img src="' + item.image.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.image.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.image.alt + '">';
    newCartHtml += '</a>';
    newCartHtml += '</div>';
    newCartHtml += '<div class="product__info">';
    newCartHtml += '<div class="d-flex space-between">';
    newCartHtml += '<h3>';
    newCartHtml += '<a href="' + item.url + '">';
    newCartHtml += item.title;
    newCartHtml += '</a>';
    newCartHtml += '</h3>';
    newCartHtml += ' <button class="remove-product"><span class="sr-only">Remove Product</span></button>';
    newCartHtml += '</div>';

    if (item.properties != null && item.properties.esrb_rating != null && item.properties.esrb_rating != '') {
      newCartHtml += esrb(item.properties.esrb_rating, item.properties.esrb_list);
    }

    newCartHtml += '<div class="actions d-flex space-between align-center">';
    newCartHtml += '<div class="product__qty d-flex">';
    newCartHtml += '<button class="js-qty--mini js-qty--minus"><span class="sr-only">Decrease</span></button><input type="text" value="' + item.quantity + '" class="qty-val" /><button class="js-qty--mini js-qty--plus"><span class="sr-only">Increase</span></button>';
    newCartHtml += '</div>';
    newCartHtml += '<div class="price">';
    newCartHtml += formatter.format(item.final_line_price / 100);
    newCartHtml += '</div>';
    newCartHtml += '</div>';
    newCartHtml += '</div>';

    if (item.properties != null && item.properties.upsell_id != null && item.properties.upsell_id != '') {
      newCartHtml += '<div class="upsell" data-upsell_id="' + item.properties.upsell_id + '">';
      newCartHtml += '<button class="d-flex space-between"><span class="title">Add ' + item.properties.upsell_title + '?</span> <span class="price">' + formatter.format(item.properties.upsell_price / 100) + '</span></button>';
      newCartHtml += '</div>';
    }

    newCartHtml += '</div>';
  });
  $('.mini-cart__products').empty();
  $('.cart-counter ').text(cartData.item_count);

  if (cartData.item_count == 1) {
    var items = ' Item';
  } else {
    var items = ' Items';
  }

  $('.mini-cart__sub-heading .cart-count').text(cartData.item_count + items);
  $('.mini-cart__subtotal').text(formatter.format(cartData.total_price / 100));
  $('.mini-cart__products').html(newCartHtml);

  if (cartData.item_count != 0) {
    $('.header .icon-cart').addClass('items');
  } else {
    $('.header .icon-cart').removeClass('items');
  }

  $('.mini-cart').fadeIn();
  setTimeout(function () {
    $('.mini-cart').addClass('cart--open');
  }, 100);
}

function esrb(rating, list) {
  var ratingList = list.split('|');
  var html = '<div class="esrb d-flex align-center">';
  html += '<img src="//cdn.shopify.com/s/files/1/0912/7444/t/17/assets/' + rating + '" alt="" />';
  html += '<div class="esrb__details">';
  jQuery.each(ratingList, function (index, item) {
    html += '<div class="detail">' + item + '</div>';
  });
  html += '</div>';
  html += '</div>';
  return html;
} // Create our number formatter.


var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD' // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

});
jQuery(document).ready(function ($) {
  $('.blog__list .list__heading select').on('change', function () {
    var tagVal = $(this).val();
    window.location = '/blogs/news/tagged/' + tagVal;
  });
});
jQuery(document).ready(function ($) {
  $('.customer--account  .launch-add-change').on('click', function (e) {
    e.preventDefault();
    $('.customer--account .change-me').toggleClass('change-show');
  });
});
// jQuery( document ).ready( function( $ ) {
//  $( '.collection__header' ).on( 'click', '.boost-pfs-filter-filter-dropdown a', function(){
//   var selectedVal = $( this ).data( 'sort' );
//   var selectedText = $( '.boost-pfs-filter-filter-dropdown a[data-select="'+selectedVal+'"]' ).text(); 
//  }  );
// });
jQuery(document).ready(function ($) {
  headerOffset();
  $(window).on('resize scroll', function () {
    headerOffset();
  });
  $('.icon-search').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('search-active');
    $('.header__search').toggleClass('search-active');
  });
  $('.mobile-trigger button').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('menu-active');
    $('html').toggleClass('menu-open');
    $('.mobile-menu').fadeToggle('fast');
  }); // Main menu stop # links

  $('.header__nav  a[href="#"]').on('click', function (e) {
    e.preventDefault();
  }); // Mobile Menu Panels
  // click menu item with children, close main menu, open matching sub panel

  $('.mobile-menu .nav--main a').on('click', function (e) {
    if ($(this).closest('li').hasClass('has-children')) {
      e.preventDefault();
      var dataMenu = $(this).data('menu-index');
      $('.mobile-menu__main').fadeOut('fast', function () {
        $('.mobile-menu__sub .nav__page[data-menu-index="' + dataMenu + '"]').fadeIn('fast');
      });
    }
  }); // close sub panel, open main menu

  $('.mobile-menu__sub .heading').on('click', function (e) {
    e.preventDefault();
    var dataParentMenu = $(this).closest('.nav__page').data('menu-index');
    $(this).closest('.nav__page').fadeOut('fast', function () {
      $('.mobile-menu__main').fadeIn('fast');
    });
  }); // click sub menu accordion to expand

  $('.nav__page .menu-header').on('click', function (e) {
    e.preventDefault();

    if ($(this).hasClass('acc-open')) {
      $(this).removeClass('acc-open');
      $(this).closest('li').find('ul').slideUp('fast');
    } else {
      $('.nav__page li ul').slideUp('fast');
      $('.nav__page .menu-header').removeClass('acc-open');
      $(this).toggleClass('acc-open');
      $(this).closest('li').find('ul').slideToggle('fast');
    }
  }); // Display mini cart

  $('.icon-cart a, .shop-link').on('click', function (e) {
    e.preventDefault(); // headerOffset();

    $('.mini-cart').fadeToggle();
    setTimeout(function () {
      $('.mini-cart').toggleClass('cart--open');
    }, 100);

    if ($(window).width() < 435) {
      $('html').toggleClass('menu-open');
    }
  });
});

function headerOffset() {
  var fixedHeight = $('.fixed-container').height();
  var newsHeight = $('.news-scroll').outerHeight();
  $('#main').css('padding-top', fixedHeight + 'px');
  $('.mobile-menu').css('top', fixedHeight + 'px');
  $('.mini-cart').css('top', fixedHeight + 'px');
  $(window).on('scroll resize', function () {
    if ($(window).scrollTop() >= 200) {
      $('.fixed-container').addClass('scrolling');
      $('.header').css('transform', 'translateY(-' + newsHeight + 'px)');
      $('.mobile-menu').css('margin-top', '-' + newsHeight + 'px');
      $('.mini-cart').css('margin-top', '-' + newsHeight + 'px');
    } else {
      $('.fixed-container').removeClass('scrolling');
      $('.header').css('transform', 'translateY(0)');
      $('.mobile-menu').css('margin-top', '0');
      $('.mini-cart').css('margin-top', '0');
    }
  });
}
// jQuery( document ).ready( function( $ ) {
//   var global = {
//     konami: function() {
//       var konamikeys = [38,38,40,40,37,39,37,39,66,65], 
//           started = false, 
//           count = 0;
//       $(document).keydown(function(e){
//         var reset = function() {
//           started = false; 
//           count = 0;
//           return;
//         };
//         key = e.keyCode;
//         // Begin watching if first key in sequence was pressed.
//         if(!started){
//           if(key == 38){ 
//             started = true;
//           }
//         }
//         // If we've started, pay attention to key presses, looking for right sequence.
//         if (started){
//           if (konamikeys[count] == key){
//             count++;
//           } else {
//             // Incorrect key, restart.
//             reset();
//           }
//           if (count == 10){
//             // Success!
//             alert('Konami code entered!');
//             // $( '.product--default .image--one' ).pixelate();
//             // $( '.pdp-slider img' ).pixelate();
//             // $( '.gallery__slider img' ).pixelate(); 
//             $( 'body' ).addClass( 'konami-code' );
//             reset();
//           }
//         } else {
//           reset();
//         }
//       });
//     }
//   }
//   global.konami();
// } )

jQuery(document).ready(function ($) {
  $('.gallery__slider').on('click', '.slick-protect a', function (e) {
    e.preventDefault();
    var imgSrc = $(this).data('img_url');
    launchModal('image', imgSrc);
  });
  $('.pdp__images').on('click', '.pdp-img-modal-link', function (e) {
    e.preventDefault();
    var imgSrc = $(this).data('img_url');
    launchModal('pdp', imgSrc);
  });
  $('.size-guide').on('click', function (e) {
    e.preventDefault();
    launchModal();
  });
  $('.modal__backdrop, .modal__close').on('click', function () {
    if ($(this).closest('.modal').hasClass('modal--gallery')) {
      closeModal('image');
    } else if ($(this).closest('.modal').hasClass('modal--pdp')) {
      closeModal('pdp');
    } else {
      closeModal();
    }
  });
});

function launchModal(type, src) {
  if (type == 'image') {
    $('.img-replace').append('<img src="' + src + '" />').fadeIn();
    $('html').addClass('modal-open');
    $('.modal--gallery').fadeIn('slow');
  } else if (type == 'pdp') {
    $('.modal--pdp .img-replace').append('<img src="' + src + '" />').fadeIn();
    $('html').addClass('modal-open');
    $('.modal--pdp').fadeIn('slow');
  } else {
    $('html').addClass('modal-open');
    $('.modal').fadeIn('slow');
  }
}

function closeModal(type) {
  if (type == 'image') {
    $('html').removeClass('modal-open');
    $('.modal--gallery').fadeOut('slow', function () {
      if ($('.img-replace').length) {
        $('.img-replace').fadeOut('slow').html('');
      }
    });
  } else if (type == 'pdp') {
    $('html').removeClass('modal-open');
    $('.modal--pdp').fadeOut('slow', function () {
      if ($('.img-replace').length) {
        $('.img-replace').fadeOut('slow').html('');
      }
    });
  } else {
    $('html').removeClass('modal-open');
    $('.modal').fadeOut('slow');
  }
}

// /*!
// Name: highlightReel
// Dependencies: jQuery
// Author: Justin Duke
// Author URL: http://jmduke.com
// Github URL: https://github.com/jmduke
// Licensed under the MIT license
// */
// (function($) {
//   $.fn.pixelate = function (options) {
//     // TODO:  There's, like, definitely more customization that we could do here.
//     var defaults = {
//       focus           : 0.5,
//       canvasID  : "pCanvas"
//     }, settings = $.extend({}, defaults, options);
//     this.each(function (index) {
//       // Since we pretty much remove the <img> element from the picture pretty quickly, we need to
//       // capture the important attributes before anything else.
//       var width = this.width;
//       var height = this.height;
//       console.log( width );
//       console.log( height );
//       var idSelector = "#" + settings.canvasID + index;
//       // Hide the image itself, since we're transposing over it.
//       $(this).hide();
//       // Edge case: in multiple invocations of pixelate(), be sure to get rid of previous attempts.
//       $(this).parent().children("canvas").remove();
//       $(this).after("<canvas id='" + idSelector.slice(1) + "''>");
//       $(idSelector).get(0).width = width;
//       $(idSelector).get(0).height = height;
//       var context = $(idSelector).get(0).getContext("2d");
//       // This is how the whole thing works.
//       context.imageSmoothingEnabled = false;
//       context.mozImageSmoothingEnabled = false;
//       context.webkitImageSmoothingEnabled = false;
//       function pixelate(image) {
//         var el = $("#" + settings.canvasID + index).get(0);
//         var relativeWidth = el.width * 0.25;
//         var relativeHeight = el.height * 0.25;
//         context.drawImage(image, image.width/2, image.height/2, relativeWidth, relativeHeight);
//         context.drawImage(el, image.width/2, image.height/2, relativeWidth, relativeHeight, 0, 0, el.width, el.height);
//       }
//       pixelate(this);
//     });
//     return this;
//   };
// }(jQuery));
jQuery(document).ready(function ($) {});
jQuery(document).ready(function ($) {
  // Top newsbar marquee
  $('.news-scroll .slider').slick({
    speed: 9000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: true
  });
  var heroSlides = $('.hero-slider .slider .slick-slide').length;

  if (heroSlides < 4) {
    $('.hero-slider .slider').addClass('no-slide');
  } // Hacky code to deal with slick classes when slider repeats


  $('.hero-slider .slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.slick-slide').removeClass('slick-try');
    $('.slick-center').addClass('slick-try');
    $('.slick-center').next().next().addClass('slick-try');
  });
  $('.slick-prev').click(function () {
    $('.hero-slider .slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.slick-slide').removeClass('slick-try');
      $('.slick-center').addClass('slick-try');
      $('.slick-center').prev().prev().addClass('slick-try');
    });
  }); // Product tabs sliders

  $('.tabs .slider').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 1045,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        arrows: false,
        centerMode: false,
        slidesToScroll: 2
      }
    }]
  });
  $('.tabs-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    LazyLoad.update();
  }); // Featured collection Main slider

  $('.slider-featured .featured__collections').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $('.slider-featured .featured-collection__slider').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $('.pdp__images .pdp-slider--main').slick({
    infinite: true,
    slidesToShow: 1,
    fade: true,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: false,
    asNavFor: '.pdp__images .pdp-slider--thumb',
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  });
  $('.pdp__images .pdp-slider--thumb').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    asNavFor: '.pdp__images .pdp-slider--main',
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true
      }
    }]
  });
  $('.pdp__gallery .gallery__slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }]
  });
  var windowW = $(window).width();

  if (windowW < 768) {
    $('.related__products').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      arrows: false,
      dots: false,
      responsive: [{
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }]
    }); // $( '.product-recommendations' ).slick({
    //   infinite: true,
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   centerMode: true,
    //   arrows: false,
    //   dots: false,
    //   responsive: [
    //     {
    //       breakpoint: 420,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: false
    //       }
    //     },
    //   ]
    // });
  }

  if (windowW < 420) {
    $('.article .content__products .mobile-slider').slick({
      infinite: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      centerMode: false,
      arrows: false,
      dots: false
    });
  }

  var lazyLoadInstance = new LazyLoad({// Your custom settings go here
  });
});
jQuery(document).ready(function ($) {
  // Mega Menu
  $('.mega-menu__tabs .menu.active').fadeIn(200);
  $('.mega-menu__tabs .tabs__list button').on('click', function (e) {
    e.preventDefault();
    var dataTab = $(this).data('tab-index');
    $('.mega-menu__tabs .tabs__list button').removeClass('active');
    $(this).addClass('active');
    $('.mega-menu__tabs .menu.active').fadeOut(200, function () {
      $('.mega-menu__tabs .menu[data-tab-index="' + dataTab + '"]').fadeIn(200).addClass('active');
      $('.mega-menu__tabs .menu[data-tab-index="' + dataTab + '"] .slider');
    }).removeClass('active');
  }); // Section home-slider-tabs

  $('.tabs__content .slider-wrap.active').fadeIn(200);
  $('.slider-tabs .tabs__list button').on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('active')) {
      var dataTab = $(this).data('tab-index');
      $('.slider-tabs .tabs__list button').removeClass('active');
      $(this).addClass('active');
      $('.tabs__content .slider-wrap.active').fadeOut(200, function () {
        $('.tabs__content .slider-wrap[data-tab-slider="' + dataTab + '"]').fadeIn(200).addClass('active');
        $('.tabs__content .slider-wrap[data-tab-slider="' + dataTab + '"] .slider').slick('setPosition');
      }).removeClass('active');
    }
  });
  $('.tabs__select select').on('change', function (e) {
    var dataTab = $(this).val();
    $('.tabs__content .slider-wrap.active').fadeOut(200, function () {
      $('.tabs__content .slider-wrap[data-tab-slider="' + dataTab + '"]').fadeIn(200).addClass('active');
      $('.tabs__content .slider-wrap[data-tab-slider="' + dataTab + '"] .slider').slick('setPosition');
    }).removeClass('active');
  }); // Section home-slider-featured

  $('.slider-featured .featured__collections').on('click', 'button', function (e) {
    e.preventDefault();
    var dataTab = $(this).data('featured-collection');

    if ($(this).closest('.featured__slide').hasClass('active')) {
      $(this).closest('.featured__slide').removeClass('active');
      $('.featured-collection[data-featured-collection="' + dataTab + '"]').fadeOut('slow');
    } else {
      $('.featured__slide').removeClass('active');
      $(this).closest('.featured__slide').addClass('active');
      $('.featured-collection').hide();
      $('.featured-collection[data-featured-collection="' + dataTab + '"]').fadeIn('slow');
      $('.featured-collection[data-featured-collection="' + dataTab + '"] .featured-collection__slider').slick('setPosition');
    }
  }); // close sub-carousel when parent slide changes

  $('.featured__collections').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.featured__slide').removeClass('active');
    $('.featured-collection').fadeOut('slow');
  });
});
console.log("This site was developed by https://www.sleeplessmedia.com");

function swymCallbackFn() {
  window._swat.wishlistCount(function (r) {
    if (r > 0) {
      $('.header .icon-list').addClass('items');
    }
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);
jQuery(document).ready(function () {
  var links = document.links;

  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});

jQuery(document).ready(function ($) {
  function prefetchImages(url) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.onreadystatechange = function() {
    if (xhr.readyState == 4) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(xhr.responseText, 'text/html');
      var images = doc.getElementsByTagName('img');
      for (var i = 0; i < images.length; i++) {
        var img = images[i];
        var src = img.getAttribute('src');
        var xhr2 = new XMLHttpRequest();
        xhr2.open('GET', src, true);
        xhr2.send();
      }
    }
  };
  xhr.send();
  }
  
  function elementScrolled(elem){
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
  }
  
  function preloadVisibleLinks(){
  if(elementScrolled('a')) {
    var thisHref = elementScrolled.attr('href');
    if (typeof thisHref !== 'undefined' && attr !== false) {
      prefetchImages(thisHref);
    }
  }
  }
  
  $(window).scroll(function(){
  preloadVisibleLinks();
  });
  preloadVisibleLinks();
});
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.